module.exports = __webpack_public_path__ + "images/backgrounds/city/large.423831fc16653d7adf55.jpg";